<template>
  <div class="app-info-card">
    <div class="app-info-card__label">
      <v-icon v-if="icon" size="14" class="mr-1">{{ icon }}</v-icon>
      {{ label }}
    </div>
    <div class="app-info-card__value">
      <slot>{{ value || "—" }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppInfoCard",
  props: {
    icon: { type: String, default: "" },
    label: { type: String, required: true },
    value: { type: [String, Number], default: "" },
  },
};
</script>

<style scoped>
.app-info-card {
  border: 1px solid #ECE7DE;
  background: #FDFCFA;
  border-radius: 10px;
  padding: 12px 14px;
  height: 100%;
}
.app-info-card__label {
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-ink);
  opacity: 0.55;
  margin-bottom: 4px;
}
.app-info-card__value {
  font-weight: 600;
  color: var(--color-ink);
  font-size: 0.95rem;
  line-height: 1.35;
}
</style>
